
import React from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import { Button, Modal, ModalBody } from 'reactstrap';
import { FiWifi } from "react-icons/fi";
import { FaFileInvoiceDollar } from "react-icons/fa"
import Support from '../../ImageAssets/Support.png';
import SwitchAccount from '../../ImageAssets/switchAccountNew.png';
import BillAccount from '../../ImageAssets/BillAccount.png';
import SettingsAccount from '../../ImageAssets/SettingsAccount.png';
import { setCache, setSwitchAccountModalTrue } from '../../General/Actions.js';
import moment from 'moment';
import Constants from '../../Utils/constants.json';
import PaymentComponent from './Payment';
import TVDisabled from '../../ImageAssets/TVNewDisabled.png';
import phoneDisabled from '../../ImageAssets/phoneCallDisabled.png';
import ictServices from '../../ImageAssets/ictServices.png';
import NoDataFound from '../../Utils/noDataFound.js';
import RechargeComponent from './RechargeComponent';
import closeIcon from '../../ImageAssets/closeIcon.png';
import Network from '../../Utils/network.js';
import ReceiptComponent from '../../Utils/receiptModal';
import noPostpaidServiceImg from '../../ImageAssets/noPostpaidServiceImg.png';
import Swal from 'sweetalert2';
import Recharge from '../../ImageAssets/Recharge.png';

class MyAccountOverviewPartComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            serviceList: [],
            userDetails: {},
            billDueDate: "",
            lastPaymentAmount: "",
            lastPaymentDate: "",
            outstandingAmount: "",
            allServicesArray: [],
            servicesArray: [],
            count: 0,
            isPaymentComponent: false,
            billStartDate: "",
            billEndDate: "",
            firstName: "",
            lastName: "",
            phoneNumber: "",
            emailId: "",
            profileId: "",
            givenAddress: {},
            allServiceName: [],
            state: "",
            serviceAddress: "",
            addServiceStatus: 1,
            addDeviceStatus: 1,
            addAddonsStatus: 1,
            settingsStatus: 1,
            changePlanStatus: 1,
            payBillStatus: 1,
            rechargeStatus: 1,
            serviceCenterStatus: 1,
            billsAndPaymentStatus: 1,
            hideBillsAndPaymentForPrepaid: false,
            allPrepaidArray: [],
            isRechargeComponentVisible: false,
            isChangePrepaidServiceModalVisible: false,
            currentPrepaidServiceId: "",
            currentPrepaidServiceName: "",
            currentPrepaidStatus: "",
            currentPrepaidBalance: "0",
            currentPrepaidBalance_sup: "00",
            isPostpaidServiceExists: false,
            planId: "",
            isReceiptModalVisible: false
        }
    }

    componentDidMount() {
        var dataToSend = {
            customerCategory: this.props.userDetails.customerCategory,
            customerSubCategory: this.props.userDetails.customerSubCategory
        }

        Network.executeAxios("fetchAccessPrivilages", "POST", dataToSend, (accessPrivilagesResponse) => {
            if (accessPrivilagesResponse.STATUS === "SUCCESS") {
                this.initializeFeatures(accessPrivilagesResponse);
            } else {
                console.log("No Restrictions found for this profile");
            }
            Network.executeAxios("checkPaymentDetails", "GET", "", (response) => {
                console.log("checkPaymentDetails >> ", response);
                if (response && response.orderId && response.reason && response.status) {
                    var reason = response.reason;
                    if (reason == "bill_payment") {
                        reason = "bill";
                    } else if (reason == "recharge") {
                        reason = "recharge";
                    } else if (reason == "add_addon") {
                        reason = "addon subscription";
                    } else if (reason == "change_plan") {
                        reason = "change plan";
                    }
                    if (response.status === "SUCCESS") {
                        setTimeout(() => {
                            Swal.fire({
                                title: "Payment Successful",
                                html: "<div>Your payment for " + reason + " has been successful</div><div style='text-align:center'>Order Id : " + response.orderId + "</div>",
                                type: '',
                                timer: 3000,
                                showCancelButton: false,
                                confirmButtonText: this.props.locales.okButtonTextInSwal,
                            }).then((result) => {
                            });
                        }, 1000);
                    } else if (response.status === "TO_REFUND") {
                        setTimeout(() => {
                            Swal.fire({
                                title: "Failed to place the order",
                                html: "<div>Amount debited will be refunded within 5 working days</div>",
                                type: '',
                                timer: 4000,
                                showCancelButton: false,
                                confirmButtonText: this.props.locales.okButtonTextInSwal,
                            }).then((result) => {
                            });
                        }, 1000);
                    } else {
                        setTimeout(() => {
                            Swal.fire({
                                title: "Payment Failed",
                                html: "<div>Your payment for " + reason + " has been Failed</div><div style='text-align:center'>Order Id : " + response.orderId + "</div>",
                                type: '',
                                timer: 3000,
                                showCancelButton: false,
                                confirmButtonText: this.props.locales.okButtonTextInSwal,
                            }).then((result) => {
                            });
                        }, 1000);
                    }
                }
                //this.manageFeatures();
                this.initializefetchServiceInfoDetails();
                this.initializeUserDetails();
                this.initializeServiceList();
            });
        });
    }

    initializeFeatures(response) {
        var featureArray = response.FEATURES;
        var finalFeatures = [];
        for (var i = 0; i < featureArray.length; i++) {
            var temp = {
                featureName: featureArray[i].FEATURE_NAME,
                status: featureArray[i].STATUS
            }
            finalFeatures.push(temp);
        }
        this.props.setUserDetails("features", finalFeatures);
        this.manageFeatures();
    }

    manageFeatures() {        // 1-show feature   0-hide feature
        var addServiceStatus = 1;
        var addDeviceStatus = 1;
        var addAddonsStatus = 1;
        var settingsStatus = 1;
        var changePlanStatus = 1;
        var payBillStatus = 1;
        var serviceCenterStatus = 1;
        var billsAndPaymentStatus = 1;
        var rechargeStatus = 1;
        var features = this.props.userDetails.features;
        if (features.length > 0) {
            for (var i = 0; i < features.length; i++) {
                if (features[i].featureName === "AddService") {
                    addServiceStatus = features[i].status;
                } else if (features[i].featureName === "AddDevice") {
                    addDeviceStatus = features[i].status;
                } else if (features[i].featureName === "Settings") {
                    settingsStatus = features[i].status;
                } else if (features[i].featureName === "AddAddons") {
                    addAddonsStatus = features[i].status;
                } else if (features[i].featureName === "ChangePlan") {
                    changePlanStatus = features[i].status;
                } else if (features[i].featureName === "PayBill") {
                    payBillStatus = features[i].status;
                } else if (features[i].featureName === "ViewServiceCenter") {
                    serviceCenterStatus = features[i].status;
                } else if (features[i].featureName === "ViewBillsAndPayments") {
                    billsAndPaymentStatus = features[i].status;
                } else if (features[i].featureName === "recharge") {
                    rechargeStatus = features[i].status;
                }
            }
        }
        this.setState({
            addServiceStatus: addServiceStatus,
            addDeviceStatus: addDeviceStatus,
            addAddonsStatus: addAddonsStatus,
            settingsStatus: settingsStatus,
            changePlanStatus: changePlanStatus,
            rechargeStatus: rechargeStatus,
            payBillStatus: payBillStatus,
            serviceCenterStatus: serviceCenterStatus,
            billsAndPaymentStatus: billsAndPaymentStatus
        })
    }

    initializeServiceList(response) {
        if (this.props.cache.serviceListResponse) {
            this.setState({ serviceList: this.props.cache.serviceListResponse });
            var ifPostpaidExists=[];
            for(var m=0; m< this.props.cache.serviceListResponse.length; m++){
                if(this.props.cache.serviceListResponse[m].connection_type === this.props.locales.connectionTypeForPostpaid || this.props.cache.serviceListResponse[m].connection_type === this.props.locales.connectionTypeForPrepaidPlus){
                    ifPostpaidExists.push("true")
                }
            }
            const isPostPaidInArray = ifPostpaidExists.includes("true");
            if(isPostPaidInArray == false) this.setState({hideBillsAndPaymentForPrepaid: true})
        }

    }

    initializefetchServiceInfoDetails() {
        var reduxCache = this.props.cache;
        var servicesArray = [];
        if (reduxCache.serviceListResponse) {
            var servicesArray = reduxCache.serviceListResponse;
        }

        var allServicesFromConfiguration = []
        var allPogIds = [];
        if (this.props.configurationValues) {
            allServicesFromConfiguration = this.props.configurationValues.productFamily
            allPogIds = this.props.configurationValues.allPog
        }

        for (var j = 0; j < servicesArray.length; j++) {
            if (Array.isArray(allServicesFromConfiguration)) {
                for (var i = 0; i < allServicesFromConfiguration.length; i++) {
                    if (servicesArray[j].network_type === allServicesFromConfiguration[i].id) {
                        servicesArray[j].service_name = allServicesFromConfiguration[i].name
                        // allServiceName.push(servicesArray[j].network_type)
                    }
                }
            }

        }

        if (Array.isArray(allPogIds)) {
            for (var y = 0; y < allPogIds.length; y++) {
                for (var z = 0; z < servicesArray.length; z++) {
                    if (servicesArray[z].connection_type === this.props.locales.connectionTypeForPrepaid) {
                        if (allPogIds[y].name.toUpperCase() === "GSMPREPAID") {
                            servicesArray[z].pog = allPogIds[y].id;
                        }
                    } else if (servicesArray[z].connection_type === this.props.locales.connectionTypeForPrepaidPlus) {
                        if (allPogIds[y].name.toUpperCase() === "PREPAIDPLUS") {
                            servicesArray[z].pog = allPogIds[y].id;
                        }
                    } else if (servicesArray[z].connection_type === this.props.locales.connectionTypeForPostpaid) {
                        if (servicesArray[z].service_name === allPogIds[y].name) {
                            servicesArray[z].pog = allPogIds[y].id;
                        }
                    } else {
                        servicesArray[z].pog = "0"
                    }
                }
            }
        }

        console.log("allPog>>>", servicesArray)

        var allServiceName = []
        if (servicesArray.length > 0) {
            if (Array.isArray(allServicesFromConfiguration)) {
                for (var x = 0; x < allServicesFromConfiguration.length; x++) {
                    allServiceName.push(allServicesFromConfiguration[x].id)
                }
            }
        }

        allServiceName = allServiceName.join(",")
        this.state.allServiceName = allServiceName
        this.state.allServicesArray = servicesArray;
        const ifPrepaidExists = servicesArray.some(services => services.connection_type !== "1");
        const ifPostpaidExists = servicesArray.some(services => services.connection_type === "1");

        if (ifPrepaidExists) {
            var prepaidArray = [];
            for (var m = 0; m < servicesArray.length; m++) {
                if (servicesArray[m].connection_type !== "1")
                    prepaidArray.push(servicesArray[m])
            }
            if (prepaidArray.length > 0) {
                this.initialiseSubscriberInfo(prepaidArray[0].service_id);
                this.setState({
                    currentPrepaidStatus: prepaidArray[0].status,
                    currentPrepaidServiceId: prepaidArray[0].service_id,
                    currentPrepaidServiceName: prepaidArray[0].service_name,
                    allPrepaidArray: prepaidArray
                })
            }
        }

        this.setState({ isPostpaidServiceExists: ifPostpaidExists, isLoading: false })
        this.props.setCache("allServiesArray", this.state.allServicesArray);
    }

    initialiseSubscriberInfo(receivedServiceId) {
        this.setState({ isLoading: true })
        Network.executeAxios("fetchSubscriberInfo", "POST", { "serviceId": receivedServiceId }, (fetchSubscriberInfoResponse) => {
            var maBalance = 0;
            var maBalance_sup = "00";

            try {
                var params = fetchSubscriberInfoResponse.service_info.basic_details;
                for (var i = 0; i < params.length; i++) {
                    if (params[i].id === "maBalance") {
                        maBalance = params[i].value
                    }
                    if (params[i].id === "rate_plan_id") {
                        this.state.planId = params[i].value
                    }
                }

            } catch (err) {

            }

            var Price = GeneralUtils.formatNumberToStandardForm(maBalance)
            Price = Price.split(".");
            maBalance = Price[0]
            if (Price.length > 1) {
                maBalance_sup = Price[1];
            } else {
                maBalance_sup = "00"
            }

            this.setState({ currentPrepaidBalance: maBalance, currentPrepaidBalance_sup: maBalance_sup, isLoading: false })
        })
    }

    initiatePayment(type) {
        if (type === "recharge") {
            this.setState({ isRechargeComponentVisible: true })
        } else {
            this.setState({ isPaymentComponent: true })
        }
    }

    changePrepaidService(type) {
        if (type === "changeService") {
            this.setState({ isChangePrepaidServiceModalVisible: true })
        } else if (type === "close") {
            this.setState({ isChangePrepaidServiceModalVisible: false })
        }
    }

    myCallback = (isPaymentComponentEnabled, isReceiptModalVisible, transactionId, finalRechargeAmount, type) => {
        if (type === "mainBalance") {
            this.setState({ receiptType: type })
        }
        this.setState({
            isPaymentComponent: isPaymentComponentEnabled,
            isRechargeComponentVisible: isPaymentComponentEnabled,
            isReceiptModalVisible: isReceiptModalVisible,
            transactionId: transactionId,
            finalRechargeAmount: finalRechargeAmount
        })
    }


    receiptCallback = () => {
        this.setState({
            isReceiptModalVisible: false,
            isLoading: false
        })
        this.initializefetchServiceInfoDetails();
        this.initialiseSubscriberInfo(this.state.currentPrepaidServiceId);
    }



    initializeUserDetails() {
        var reduxCache = this.props.cache;
        try {
            var accountInfo = reduxCache.fetchAccountDetailsResponse;
            var accountInfoParams = accountInfo.BillingSystem.response.dataset.account_info[0];
            var accountBalanceDetails = accountInfoParams.balance_details;

            console.log("fetchAccountDetailsResponse", reduxCache.fetchAccountDetailsResponse)

            this.setState({
                profileId: accountInfoParams.profile_id,
                accountId: accountInfoParams.account_id,
                firstName: accountInfoParams.billing_name,
                lastName: accountInfoParams.last_name,
                emailId: accountInfoParams.notification_email_id,
                billDueDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.bill_due_date, this.props.configurationValues.dateFormatForBilling),
                lastPaymentAmount: GeneralUtils.formatNumberToStandardForm(accountBalanceDetails.last_payment_amount),
                lastPaymentDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.last_payment_date, this.props.configurationValues.dateFormatForBilling),
                outstandingAmount: GeneralUtils.formatNumberToStandardForm(accountBalanceDetails.outstanding_balance),
                billStartDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.from_bill_date, this.props.configurationValues.dateFormatForBilling),
                billEndDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.to_bill_date, this.props.configurationValues.dateFormatForBilling),

            });

            var outstandingAmountFinal = GeneralUtils.formatNumberToStandardForm(accountBalanceDetails.outstanding_balance)

            var oustandingAmountMain = ""
            var oustandingAmountSup = ""
            try {
                if (outstandingAmountFinal != "") {
                    var price = outstandingAmountFinal;
                }
                price = price.split(".");
                oustandingAmountMain = price[0]
                if (price.length > 1) {
                    oustandingAmountSup = price[1];
                } else {
                    oustandingAmountSup = "00"
                }
            } catch (err) {
                oustandingAmountMain = 0
                oustandingAmountSup = "00"
            }
            this.state.oustandingAmountMain = oustandingAmountMain
            this.state.oustandingAmountSup = oustandingAmountSup
            console.log("accountInfoParams.contact_number_1,", this.state.oustandingAmountMain)
        } catch (err) {

        }
        try {
            var receivedResponse = reduxCache.querySubscriberResponse;
            var params = receivedResponse.profile_info.basic_details;
            var finalContactNumber = "";

            for (var i = 0; i < params.length; i++) {
                if (params[i].id === "contact_number_1") {
                    finalContactNumber = params[i].value;
                }
            }
            this.setState({ phoneNumber: finalContactNumber })
        } catch (err) {

        }

        this.setState({ "dummy": "dummy" })
    }

    manageServiceClicked(type, serviceId, serviceAddress, receivedPog, receivedConnectionType) {
        window.scrollTo(0, 0)

        var allServiceId = []
        for (var i = 0; i < this.state.allServicesArray.length; i++) {
            var currentService = this.state.allServicesArray[i];
            if (currentService.service_id) {
                let temp = {
                    "serviceName": currentService.service_name,
                    "serviceId": currentService.service_id
                }
                allServiceId.push(temp)
            }
        }

        this.state.givenAddress = {
            AddressLine1: serviceAddress.addr_line1,
            city: serviceAddress.addr_line3,
            state: serviceAddress.addr_line4,
            zip: serviceAddress.addr_line5,
            AddressLine2: serviceAddress.addr_line2,
            AddressLine6: serviceAddress.addr_line6,
            SiteId: serviceAddress.addr_line6,
            serviceId: serviceId,
            profileId: this.state.profileId,
            address: serviceAddress,
            allServiceId: allServiceId,
            pog: receivedPog,
            connectionType: receivedConnectionType
        }

        this.props.subMenuClicked(type, serviceId, this.state.givenAddress);

        var temp = {
            "type": type,
            "serviceId": serviceId,
            "serviceAddress": this.state.givenAddress
        }
        this.props.setCache("dataForMyAccountRedirection", temp);

    }

    populateServiceList() {
        const allServices = this.state.allServicesArray.map((item, key) => {
            if (item.status !== "4" && item.status !== "6" && (item.service_name.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() || item.service_name.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase() || item.service_name.toUpperCase() === this.props.locales.productFamilyNameForIct.toUpperCase() || item.service_name.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase())) {
                this.state.count = 1;
                var receivedAddress = {}
                if (item && item.addresses) {
                    receivedAddress = item.addresses[0]
                }
                var connectionType = "Postpaid"
                if (item.connection_type !== "1") {
                    connectionType = "Prepaid"
                }
                return (
                    <div className="col-lg-3 col-md-4 mt-3 mr-0 px-0 allServiceContainer" key={key}>
                        <div className="allServiceBox" style={{ width: '93%' }}>
                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() ?
                                <div>
                                    {item.status === "1" ?
                                        <div className="col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus mx-auto" style={{ width: '34%' }}>{this.props.locales.activeServiceStatusInOverview}</div></div>
                                        :
                                        null}
                                    {item.status === "0" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preActiveServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "2" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.suspendedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "3" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preTerminatedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "4" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.terminatedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                </div>
                                : null}
                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() ?
                                <div className="d-flex px-3 justify-content-between">
                                    <div ><FiWifi size="23" color="#b3b3b3" style={{ opacity: '0.5' }} /></div>
                                </div>
                                :
                                null
                            }

                            {/* ICT */}

                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForIct.toUpperCase() ?
                                <div>
                                    {item.status === "1" ?
                                        <div className="col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus mx-auto" style={{ width: '34%' }}>{this.props.locales.activeServiceStatusInOverview}</div></div>
                                        :
                                        null}
                                    {item.status === "0" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preActiveServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "2" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.suspendedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "3" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preTerminatedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "4" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.terminatedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                </div>
                                : null}
                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForIct.toUpperCase() ?
                                <div className="d-flex px-3  justify-content-between ">
                                    <div ><img src={ictServices} alt="" /></div>
                                </div>
                                :
                                null
                            }


                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase() ?
                                <div>
                                    {item.status === "1" ?
                                        <div className="col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus mx-auto" style={{ width: '34%' }}>{this.props.locales.activeServiceStatusInOverview}</div></div>
                                        :
                                        null}
                                    {item.status === "0" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preActiveServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "2" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.suspendedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "3" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preTerminatedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "4" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.terminatedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                </div>
                                : null}
                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase() ?
                                <div className="d-flex px-3  justify-content-between ">
                                    <div ><img src={phoneDisabled} alt="" /></div>
                                </div>
                                :
                                null
                            }

                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase() ?
                                <div>
                                    {item.status === "1" ?
                                        <div className="col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus mx-auto" style={{ width: '34%' }}>{this.props.locales.activeServiceStatusInOverview}</div></div>
                                        :
                                        null}
                                    {item.status === "0" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preActiveServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "2" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.suspendedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "3" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preTerminatedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                    {item.status === "4" ?
                                        <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.terminatedServiceStatusInOverview}</div></div>
                                        : null
                                    }
                                </div> : null}
                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase() ?
                                <div className="d-flex px-3  justify-content-between ">
                                    <div ><img src={TVDisabled} alt="" /></div>
                                </div>
                                :
                                null
                            }
                            <div className="pl-3 pt-2" style={{ color: '#231F20', fontWeight: 500, fontSize: 18 }}>{item.service_name}</div>
                            {item.service_name.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase()
                                ?
                                <div className="pl-3 pb-2" style={{ color: '#231F20', fontSize: 12, height: 20 }}>{connectionType}</div>
                                :
                                <div className="pl-3 pb-2" style={{ color: '#231F20', fontSize: 12, height: 20 }}></div>
                            }
                            <div className="pl-3 pt-2 pb-1" style={{ color: '#B3B3B3', fontWeight: 500, fontSize: 11 }}>{this.props.locales.serviceIdLabelForServiceBoxInOverview}</div>
                            <div className="pl-3 pt-1 pb-2" style={{ color: '#231F20', fontWeight: 500, fontSize: 14 }}>{item.service_id}</div>
                            <div className="py-2 text-center" style={{ color: '#407CCA', fontWeight: 500, fontSize: 12, borderTop: '1px solid #eaedf0', cursor: 'pointer' }}
                                onClick={() => { this.manageServiceClicked((item.service_name).toUpperCase(), item.service_id, receivedAddress, item.pog, item.connection_type) }}>
                                {this.props.locales.manageServiceLinkInOverview}
                            </div>
                        </div>
                    </div>
                )

            }

        })

        if (this.state.count > 0) {
            return (allServices)
        } else {
            return (<div className="col-md-12 row p-0 mx-auto"><div className="col-md-12 row mt-1 mx-2 mx-auto p-0"><NoDataFound content="No services found" /></div></div>)
        }

    }

    switchAccountLink() {
        this.props.setSwitchAccountModalTrue();
    }

    userSelectChangePrepaidService(receivedItem) {
        this.initialiseSubscriberInfo(receivedItem.service_id);
        this.setState({
            isLoading: true,
            currentPrepaidStatus: receivedItem.status,
            currentPrepaidServiceName: receivedItem.service_name,
            currentPrepaidServiceId: receivedItem.service_id
        })
        setTimeout(() => {
            this.setState({
                isLoading: false,
                isChangePrepaidServiceModalVisible: false
            });
        }, 1000);
    }

    populateAllPrepaidServices() {
        var currentService = this.state.currentPrepaidServiceId
        const allPrepaidServices = this.state.allPrepaidArray.map((item, key) => {
            if (currentService === item.service_id) {
                return (
                    <div className="col-md-6 mb-4" key={key}>
                        <div className="switchAccountDetail d-flex mx-auto" style={{ border: '1.5px solid #0049A5', cursor: 'not-allowed' }}>
                            <span className="m-0 pt-0 text-center" style={{ color: '#ffffff', backgroundColor: '#0049A5', borderBottomLeftRadius: 5, borderBottomRightRadius: 5, width: '30%', position: 'absolute', top: 1, right: '35%', fontSize: 10, fontWeight: 500 }}>Selected Service</span>
                            <div className="pl-3 p-0 pt-2 my-auto" style={{ width: '100%' }}>
                                <div className="" style={{ fontSize: 16, fontWeight: 500, color: '#404042' }}>{item.service_name}</div>
                                <div className="" style={{ fontSize: 14, fontWeight: 500, color: '#404042' }}>{item.service_id}</div>
                            </div>
                        </div>
                    </div>
                );
            }
            else {
                return (
                    <div className="col-md-6 mb-4 " key={key}>
                        <div className="switchAccountDetail d-flex mx-auto" onClick={() => this.userSelectChangePrepaidService(item)}>
                            <div className="pl-3 p-0 pt-2 my-auto" style={{ width: '100%' }}>
                                <div className="" style={{ fontSize: 16, fontWeight: 500, color: '#404042' }}>{item.service_name}</div>
                                <div className="" style={{ fontSize: 14, fontWeight: 500, color: '#404042' }}>{item.service_id}</div>
                            </div>
                        </div>
                    </div>
                );
            }
        });
        return (<div className="switchAccountDetailContainer col-md-12 row" style={{ marginTop: '-47px', backgroundColor: 'transparent' }}>{allPrepaidServices}</div>)
    }

    render() {
        return (
            <div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>

        );
    }

    componentContent() {
        return (
            <div id="myAccountOverviewContainer" className="animated fadeIn px-sm-5 px-0 my-5">
               <div className="px-4 ml-2 mb-1 pt-sm-0 pt-4 pb-2">
                    <div className="pl-1 col-md-12 d-none d-lg-block" style={{ color: '#231F20', fontSize: 24, fontWeight: 300 }}>{this.props.locales.welcomeTextInOverview} <span style={{ fontWeight: 600, wordBreak: 'break-word' }}>{this.state.firstName}</span></div>
                    <div className="pl-1 d-none d-lg-block" style={{ color: '#231F20', fontSize: 18, fontWeight: 300 }}>{this.props.locales.overviewTitleHeadInOverview}</div>
                </div>

                <div className="col-md-12 d-flex row m-0 justify-content-between px-sm-4 px-0">
                    <div className="col-lg-8 col-md-12 mt-sm-4 mt-0 col-12 px-sm-3 px-1" >
                        {this.state.allPrepaidArray.length > 0
                            ?
                            <div className="col-md-12 col-12 row myAccountOuterContainer mx-auto">
                                {this.state.isPostpaidServiceExists ?
                                    <div className="p-3 col-md-6 col-12">
                                        <div className="myAccountHeadingText">{this.props.locales.postpaidSectionHeadingInOverview}</div>
                                        <div className="col-md-12 d-flex row m-0 p-0 mt-2 justify-content-between">
                                            <div className="col-md-12 myAccountMyBillBox pb-2">
                                            <div className="col-md-12 p-0">
                                                    {moment(this.state.billDueDate, "MM-DD-YYYY", "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days') <= 0 && (parseFloat(this.state.outstandingAmount) <= 0 ) ?
                                                      <div className="mx-auto" style={{ width: '40%' }}><div className="serviceStatus px-2  p-0 m-0 text-center" >{this.props.locales.myAccountOverViewPartPaidTxt}</div></div>
                                                      :null }
                                                    {moment(this.state.billDueDate, "MM-DD-YYYY", "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days') > 0 && (parseFloat(this.state.outstandingAmount) <= 0 ) ?
                                                      <div className="mx-auto" style={{ width: '40%', visibility: 'hidden' }}><div className="serviceStatus px-2  p-0 m-0 text-center" >{this.props.locales.myAccountOverViewPartPaidTxt}</div></div>
                                                      :null }
                                                    {moment(this.state.billDueDate, "MM-DD-YYYY", "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days') <= 0 && parseFloat(this.state.outstandingAmount) > 0 ?
                                                      <div className="mx-auto" style={{ width: '40%' }}><div className="billPaymentStatus px-2  p-0 m-0 text-center" style={{ backgroundColor: "#e2173654", color: "#E21736", width: 130 }}>{this.props.locales.myAccountOverViewPartOverDueTxt}</div></div>
                                                    :null }
                                                   
                                                    {this.state.billDueDate.indexOf('000') < 0 ?
                                                     null
                                                     : 
                                                     <div className=" billPaymentStatus px-2 col-md-4 p-0 m-0 text-center" style={{ visibility: 'hidden', backgroundColor: "#e9cc98", color: "#8a5b04" }}>{this.props.locales.myAccountOverViewPartDueInTxt}&nbsp;{(moment(this.state.billDueDate, "MM-DD-YYYY", "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days'))}</div> }
                                                </div>

                                                <div className="col-md-12 p-0 ">
                                                    <div className="col-md-10 p-0 m-0 pt-1" style={{ color: '#b3b3b3', fontSize: 14 }}>{this.props.locales.amountDueLabelForPostpaidInOverview}</div>
                                                </div>
                                                <div className="d-flex" style={{ alignItems: 'center' }}>
                                                    <div style={{ color: '#000000', fontWeight: 300 }} className="d-flex"><span style={{ fontSize: 17 }}>{Constants.dollarSign}</span><span style={{ fontSize: 30, lineHeight: '30px' }}>{this.state.oustandingAmountMain}</span><span style={{ fontSize: 17 }}>{this.state.oustandingAmountSup}</span></div>
                                                </div>

                                                {this.state.billDueDate.indexOf('000') < 0 ?
                                                    <div className="py-2" style={{ color: '#231F20', fontSize: 14, fontWeight: 500 }}>
                                                        {this.props.locales.dueByTextForPostpaidInOverview} <nobr><span style={{ color: '#231F20' }}> {this.state.billDueDate}</span></nobr>
                                                    </div>
                                                    :
                                                    <div className="py-2" style={{ color: '#231F20', fontSize: 14, fontWeight: 500 }}>{this.props.locales.noBillGeneratedMsgForPostpaidInOverview}</div>
                                                }

                                                {this.state.payBillStatus == 1 ?
                                                    <div className="col-md-12 row text-right pr-0 mx-auto align-item-center">
                                                        <div className="col-md-6 p-0 my-auto" style={{ visibility: 'hidden' }}>
                                                            <Link to="/billingAndPayments" style={{ color: '#000', textDecoration: 'none' }}>
                                                                <div className="myAccountHeadingText_  mr-3" style={{ fontSize: 12, color: '#407CCA', fontWeight: 500 }}>{this.props.locales.seeMyBillsTextForPostpaidInOverview}</div>
                                                            </Link>
                                                        </div>
                                                        <div className="col-md-6 p-0">
                                                            <button className="btn  paymentButton" onClick={() => { this.initiatePayment() }}>&nbsp;&nbsp;{this.props.locales.myAccountOverviewPayNowBtn}&nbsp;&nbsp;</button>
                                                        </div>
                                                    </div>
                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="p-3 col-md-6 col-12 d-none">
                                        <div className="myAccountHeadingText">{this.props.locales.postpaidSectionHeadingInOverview}</div>
                                        <div className="col-md-12 d-flex row m-0 p-0 mt-2 justify-content-center">
                                            <div className="col-md-12 myAccountMyBillBox py-3 row justify-content-center align-items-center">
                                                <div className="col-md-12 text-center"> <img src={noPostpaidServiceImg} alt="" /></div>
                                                <div style={{ color: '#B3B3B3', fontSize: 18, fontWeight: 500 }}>{this.props.locales.noActiveServiceMsgForPostPaidInOverview}</div>
                                                <div style={{ color: '#231F20', fontSize: 12 }}>{this.props.locales.contactCustomerCareMsgForPostPaidInOverview}</div>
                                                <div style={{ color: '#0285CA', fontSize: 12 }}>{this.props.locales.forgetPswUserNameNumberTxt}</div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="p-3 col-md-12 col-12">
                                    <div className="myAccountHeadingText">{this.props.locales.prepaidSectionHeadingInOverview}</div>
                                    <div className="col-md-12 d-flex row m-0 p-0 mt-2 justify-content-between">
                                        <div className="col-md-12 myAccountMyBillBox pb-2">
                                            <div>
                                                {this.state.currentPrepaidStatus === "1" ?
                                                    <div className="col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus mx-auto" style={{ width: '34%' }}>{this.props.locales.activeServiceStatusInOverview}</div></div>
                                                    :
                                                    null}
                                                {this.state.currentPrepaidStatus === "0" ?
                                                    <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preActiveServiceStatusInOverview}</div></div>
                                                    : null
                                                }
                                                {this.state.currentPrepaidStatus === "2" ?
                                                    <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.suspendedServiceStatusInOverview}</div></div>
                                                    : null
                                                }
                                                {this.state.currentPrepaidStatus === "3" ?
                                                    <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.preTerminatedServiceStatusInOverview}</div></div>
                                                    : null
                                                }
                                                {this.state.currentPrepaidStatus === "4" ?
                                                    <div className=" col-md-12 p-0 m-0 text-center" style={{ height: 21 }} ><div className="serviceStatus_inactive mx-auto" style={{ width: '35%' }}>{this.props.locales.terminatedServiceStatusInOverview}</div></div>
                                                    : null
                                                }
                                            </div>

                                            <div className="col-md-12 p-0 mt-4">
                                                <div className="col-md-10 p-0 m-0" style={{ color: '#231F20', fontSize: 16, fontWeight: 500 }}>{this.state.currentPrepaidServiceName}</div>
                                            </div>
                                            <div className="d-flex pt-1" style={{ alignItems: 'center' }}>
                                                <div style={{ color: '#000000', fontWeight: 300 }} className="d-flex"><span style={{ fontSize: 17 }}>{Constants.dollarSign}</span><span style={{ fontSize: 30, lineHeight: '30px' }}>{this.state.currentPrepaidBalance}</span><span style={{ fontSize: 17 }}>{this.state.currentPrepaidBalance_sup}</span></div>
                                            </div>

                                            <div className="pb-2 pt-1" style={{ color: '#B3B3B3', fontWeight: 500, fontSize: 11 }}>
                                                {this.state.currentPrepaidServiceId}
                                            </div>


                                            <div className="col-12 row text-right pr-sm-0 pr-3 mx-auto m-0">
                                                <div className="col-6 p-0 my-auto">
                                                    {this.state.allPrepaidArray.length > 1 ?
                                                        <div className="myAccountHeadingText_ mr-3" style={{ fontSize: 12, color: '#407CCA', fontWeight: 500, cursor: 'pointer' }} onClick={() => { this.changePrepaidService("changeService") }}>{this.props.locales.changeServiceLinkForPrepaidInOverview}</div>
                                                        :
                                                        null
                                                    }
                                                </div>
                                                <div className="col-6 p-0">
                                                    {this.state.rechargeStatus == 1 ?
                                                        <button className="btn chngPlanButton" onClick={() => { this.initiatePayment("recharge") }}>&nbsp;&nbsp;{this.props.locales.rechargeLinkTxtOverview}&nbsp;&nbsp;</button>
                                                    : null }
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="p-3 myAccountOuterContainer">
                                <div className="myAccountHeadingText">{this.props.locales.myBillSectionheadingInOverview}</div>
                                <div className="col-md-12 d-flex row m-0 p-0 mt-2 justify-content-between">
                                    <div className="col-md-12 myAccountMyBillBox pb-2">
                                    <div className="col-md-12 p-0">
                                        { moment(this.state.billDueDate, "MM-DD-YYYY", "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days') <= 0 && (parseFloat(this.state.outstandingAmount) <= 0 ) ?
                                            <div className="mx-auto" style={{ width: '40%' }}><div className="serviceStatus px-2  p-0 m-0 text-center" >{this.props.locales.myAccountOverViewPartPaidTxt}</div></div>
                                        :null }
                                        { moment(this.state.billDueDate, "MM-DD-YYYY", "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days') > 0 && (parseFloat(this.state.outstandingAmount) <= 0 ) ?
                                            <div className="mx-auto" style={{ width: '40%', visibility: 'hidden' }}><div className="serviceStatus px-2  p-0 m-0 text-center" >{this.props.locales.myAccountOverViewPartPaidTxt}</div></div>
                                        :null }
                                        { moment(this.state.billDueDate, "MM-DD-YYYY", "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days') <= 0 && parseFloat(this.state.outstandingAmount) > 0 ?
                                            <div className="mx-auto" style={{ width: '40%' }}><div className="billPaymentStatus px-2  p-0 m-0 text-center" style={{ backgroundColor: "#e2173654", color: "#E21736", width: 130 }}>{this.props.locales.myAccountOverViewPartOverDueTxt}</div></div>
                                        :null }
                                        
                                        {this.state.billDueDate.indexOf('000') < 0 ?
                                            null
                                            : 
                                            <div className=" billPaymentStatus px-2 col-md-4 p-0 m-0 text-center" style={{ visibility: 'hidden', backgroundColor: "#e9cc98", color: "#8a5b04" }}>{this.props.locales.myAccountOverViewPartDueInTxt}&nbsp;{(moment(this.state.billDueDate, "MM-DD-YYYY", "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days'))}</div> }
                                        </div>

                                        <div className="col-md-12 p-0 ">
                                            <div className="col-md-10 p-0 m-0 pt-1" style={{ color: '#b3b3b3', fontSize: 14, fontWeight: 500 }}>{this.props.locales.amountDueLabelForPostpaidInOverview}</div>
                                        </div>
                                        <div className="my-2 d-flex" style={{ alignItems: 'center' }}>
                                            <div style={{ color: '#000000', fontWeight: 500 }} className="d-flex"><span style={{ fontSize: 17 }}>{Constants.dollarSign}</span><span style={{ fontSize: 30, lineHeight: '30px' }}>{this.state.oustandingAmountMain}</span><span style={{ fontSize: 17 }}>{this.state.oustandingAmountSup}</span></div>
                                        </div>

                                        {this.state.billDueDate.indexOf('000') < 0 ?
                                            <div className="py-2" style={{ color: '#231F20', fontSize: 14, fontWeight: 500 }}>
                                                {this.props.locales.dueByTextForPostpaidInOverview} <nobr><span style={{ color: '#231F20' }}> {this.state.billDueDate}</span></nobr>
                                            </div>
                                            :
                                            <div className="py-2" style={{ color: '#231F20', fontSize: 14, fontWeight: 500 }}>{this.props.locales.noBillGeneratedMsgForPostpaidInOverview}</div>
                                        }

                                        <div className="d-flex justify-content-between mt-2" >

                                            {this.state.payBillStatus == 1 ?
                                                <div className="col-md-12 row text-right pr-0 mx-auto">
                                                    <div className="col-md-6">
                                                    </div>
                                                    <div className="col-md-6 text-right pr-0 d-flex justify-content-end align-items-center">
                                                        <div className="">
                                                            <Link to="/billingAndPayments" style={{ color: '#000', textDecoration: 'none' }}>
                                                                <div className="myAccountHeadingText_ mr-3" style={{ textAlign: "center", fontSize: 12, color: '#407CCA', fontWeight: 500 }}>{this.props.locales.seeMyBillsTextForPostpaidInOverview}</div>
                                                            </Link>
                                                        </div>
                                                        <button className="btn  paymentButton" onClick={() => { this.initiatePayment() }} style={{ marginTop: -7 }}>&nbsp;&nbsp;{this.props.locales.myAccountOverviewPayNowBtn}&nbsp;&nbsp;</button>
                                                    </div>
                                                </div>
                                                : null}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        }
                    </div>
                    <div className="col-lg-4 col-md-12 mt-4">
                        <div className="p-3 quickLinksOuterContainer">
                            <div className="myAccountHeadingText">{this.props.locales.myAccountOverViewPartQuickLinksTxt}</div>
                            <div className="col-md-12 d-flex row m-0 p-0 justify-content-between">

                                {this.state.isPostpaidServiceExists ?
                                    <div className="col-md-6 mt-2 pr-sm-2 pr-0 pl-0">
                                        <div className="overviewQuickLinksBox" style={{ cursor: 'pointer' }} onClick={() => { this.initiatePayment() }}>
                                            <Button color="link" className="logoutButton mt-1 w-100"><img alt="" src={Recharge} /></Button>
                                            <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverviewPayNowBtn}</div>
                                        </div>
                                    </div>
                                    :
                                    <>
                                        {this.state.rechargeStatus == 1 ?
                                            <div className="col-md-6 mt-2 pr-sm-2 pr-0 pl-0">
                                                <div className="overviewQuickLinksBox" style={{ cursor: 'pointer' }} onClick={() => { this.initiatePayment("recharge") }}>
                                                    <Button color="link" className="logoutButton mt-1 w-100"><img alt="" src={Recharge} /></Button>
                                                    <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.rechargeLinkTxtOverview}</div>
                                                </div>
                                            </div>
                                            :
                                            <div className="col-md-6 mt-2 pr-sm-2 pr-0 pl-0">
                                                <div className="overviewQuickLinksBox" style={{ cursor: 'not-allowed' }} >
                                                    <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }}><img alt="" src={Recharge} /></Button>
                                                    <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.rechargeLinkTxtOverview}</div>
                                                </div>
                                            </div>
                                        }
                                    </>
                                }

                                {this.state.serviceCenterStatus == 1 ?
                                    <div className="col-md-6 mt-2 pl-sm-2 pl-0 pr-0">
                                        <div className="overviewQuickLinksBox">
                                            <Link to="/serviceCenter" style={{ color: '#000', textDecoration: 'none' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" ><img alt="" src={Support} /></Button>
                                                <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSupportBtn}</div>
                                            </Link>
                                        </div>
                                    </div>
                                    :
                                    <div className="col-md-6 mt-2 pl-sm-2 pl-0 pr-0">
                                        <div className="overviewQuickLinksBox" style={{ cursor: 'not-allowed' }}>
                                            <Link to="" style={{ color: '#000', textDecoration: 'none', cursor: 'not-allowed' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }} ><img alt="" src={Support} /></Button>
                                                <div className="myAccountHeadingText_" style={{ cursor: 'not-allowed', textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSupportBtn}</div>
                                            </Link>
                                        </div>
                                    </div>
                                }

                                {this.state.settingsStatus == 1 ?
                                    <div className={this.state.billsAndPaymentStatus == 1 && this.state.hideBillsAndPaymentForPrepaid == false ? "col-md-6 mt-3 pr-sm-2 pr-0 pl-0" : "col-md-12 mt-3 p-0"}>
                                        <div className="overviewQuickLinksBox">
                                            <Link to="/settings" style={{ color: '#000', textDecoration: 'none' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" ><img src={SettingsAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSettingsBtn}</div>
                                            </Link>
                                        </div>
                                    </div>
                                    :
                                    <div className={this.state.billsAndPaymentStatus == 1 && this.state.hideBillsAndPaymentForPrepaid == false ? "col-md-6 mt-3 pr-sm-2 pr-0 pl-0" : "col-md-12 mt-3 p-0"}>
                                        <div className="overviewQuickLinksBox" style={{ cursor: 'not-allowed' }}>
                                            <Link to="" style={{ color: '#000', textDecoration: 'none', cursor: 'not-allowed' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }}><img src={SettingsAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ cursor: 'not-allowed', textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSettingsBtn}</div>
                                            </Link>
                                        </div>
                                    </div>
                                }

                                {this.state.billsAndPaymentStatus == 1 && this.state.hideBillsAndPaymentForPrepaid == false ?
                                    <div className="col-md-6 mt-3 col-md-6 mt-2 pl-sm-2 pl-0 pr-0">
                                        <div className="overviewQuickLinksBox">
                                            <Link to="/billingAndPayments" style={{ color: '#000', textDecoration: 'none' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100"><img alt="" src={BillAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartBillsBtn}</div>
                                            </Link>
                                        </div>
                                    </div>
                                    :
                                   null
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" d-flex justify-content-between mt-5 px-4">
                    <div className="px-3" style={{ color: '#231F20', fontSize: 28, fontWeight: 300 }}>{this.props.locales.myServicesHeadingInOverview}</div>
                </div>
                <div style={{ paddingLeft: 16 }} className="px-4">
                    <div className="col-md-12 row mb-4 m-0 px-3" id="myAccountServiceContainer">
                        {this.populateServiceList()}
                    </div>
                </div>

                {this.state.isPaymentComponent ?
                    <PaymentComponent amount={this.state.outstandingAmount}
                        accountId={this.state.accountId}
                        billDueDate={this.state.billDueDate}
                        billStartDate={this.state.billStartDate}
                        billEndDate={this.state.billEndDate}
                        billPeriod=""
                        billId=""
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        phoneNumber={this.state.phoneNumber}
                        emailId={this.state.emailId}
                        profileId={this.state.profileId}
                        callbackFromParent={this.myCallback}
                    />
                    :
                    null
                }

                <Modal isOpen={this.state.isChangePrepaidServiceModalVisible} size="lg" centered>
                    <ModalBody>
                        <div style={{ position: "absolute", top: 20, right: 20, cursor: 'pointer', zIndex: 1000, color: '#231F20' }} onClick={() => { this.changePrepaidService("close") }}>
                            <img src={closeIcon} alt="" />
                        </div>
                        <div className="switchAccountOuterMainContainer col-md-12 p-0 pb-5" style={{ borderRadius: 6 }}>
                            <div className="col-md-12 " style={{ height: '125px', borderRadius: '6px 6px 0 0px', background: '#EBEBEB', position: 'relative' }}>
                                <div className="col-md-12 pt-4" style={{ color: '#231F20', fontSize: 24, fontWeight: '25px', paddingLeft: 62 }}>{this.props.locales.selectServiceTextInChangeServiceModal}</div>
                            </div>
                            {this.populateAllPrepaidServices()}
                        </div>

                    </ModalBody>
                </Modal>


                {this.state.isRechargeComponentVisible ?
                    <RechargeComponent amount=""
                        accountId={this.state.accountId}
                        billDueDate=""
                        billStartDate=""
                        billEndDate=""
                        billPeriod=""
                        billId=""
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        phoneNumber={this.state.phoneNumber}
                        emailId={this.state.emailId}
                        profileId={this.state.profileId}
                        serviceId={this.state.currentPrepaidServiceId}
                        planId={this.state.planId}
                        callbackFromRechargeComponent={this.myCallback}
                    />
                    : null}

                {this.state.isReceiptModalVisible ?
                    <ReceiptComponent amount=""
                        isVisible={true}
                        content={this.props.locales.rechargeSuccessInReceiptModal}
                        transactionId={this.state.transactionId}
                        serviceId={this.state.currentPrepaidServiceId}
                        finalRechargeAmount={this.state.finalRechargeAmount}
                        callback={this.receiptCallback}
                    />
                    : null}

            </div>

        );
    }


}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        changeEquipmentDetails: state.changeEquipmentDetails,
        configurationValues: state.configurationValues,
        contextParameters: state.contextParameters,
        userDetails: state.userDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSwitchAccountModalTrue: function () {
            dispatch(setSwitchAccountModalTrue());
        },
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        }
    }
}

const MyAccountOverviewPartComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyAccountOverviewPartComponent)

export default MyAccountOverviewPartComponentContainer;
